import { render, staticRenderFns } from "./OnboardTips.vue?vue&type=template&id=7e65396a&scoped=true&"
import script from "./OnboardTips.vue?vue&type=script&lang=js&"
export * from "./OnboardTips.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e65396a",
  null
  
)

export default component.exports